import type { SimulatorEvent } from '@/backendApis';
import { YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { describeEvent, textsByMessageId } from './channel-simulator.events';
import { SIMULATOR_CHANNEL_LABELS } from './channel-simulator.types';

export const SimulatorLog = ({
  events,
  selectedSeq,
  onSelect,
}: {
  events: SimulatorEvent[];
  selectedSeq: number | null;
  onSelect: (seq: number) => void;
}) => {
  const messageTexts = textsByMessageId(events);
  const newestFirst = [...events].reverse();

  return (
    // Newest first in a reversed column: the browser then keeps the view on the latest event
    <YStack className="min-h-0 flex-1 flex-col-reverse overflow-y-auto rounded-lg border border-border bg-background-subtle p-1">
      {events.length === 0 && (
        <span className="px-2 py-2 text-xs text-foreground-subtle">
          Nothing yet. Send a message.
        </span>
      )}
      {newestFirst.map((event) => (
        <button
          key={event.seq}
          type="button"
          onClick={() => onSelect(event.seq)}
          className={cn(
            'flex w-full items-baseline gap-3 rounded-md px-2 py-1 text-left font-mono text-xs hover:bg-secondary-hover',
            event.seq === selectedSeq && 'bg-secondary-active'
          )}
        >
          <span className="w-6 shrink-0 text-foreground-subtle">
            {event.seq}
          </span>
          <span className="shrink-0 text-foreground-subtle">
            {new Date(event.at).toLocaleTimeString()}
          </span>
          <span className="w-16 shrink-0 text-foreground-subtle">
            {SIMULATOR_CHANNEL_LABELS[event.channel]}
          </span>
          <span className="min-w-0 whitespace-pre-wrap break-words">
            {describeEvent(event, messageTexts)}
          </span>
        </button>
      ))}
    </YStack>
  );
};
